<div
  [ngClass]="{
    'pie-chart-extra-large': extraLarge,
    'pie-chart-large': large,
    'pie-chart-medium': medium,
    'pie-chart-small': small
  }"
  #chart
></div>
